new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#product-detail',
    data: {
        // Showcase
        showOpened: false,
        expandDesc: false,
        installmentOpened: false,

        //Thumb
        imgSrc: '',
        imgTitle: '',
        isVideo: '',
        addTogetherTemplate: null
    },
    methods: {
        moveThumbs() {
            if ($('.product-detail__header--photoArea-thumbs-default') && $('#product-photo')) {
                document.querySelectorAll('.product-detail__header--photoArea-thumbs-default li').forEach((thumb, index) => {
                    thumb.addEventListener('click', () => {
                        const targetLi = document.querySelectorAll('#product-photo li')[index];
                        if (targetLi) {
                            targetLi.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        }
                    });
                });
            }
        },
        getInfo(event, id) {
            axios.get(`/api/front/product/${id}/get-linked-product/`)
                .then(res => {
                    const actualElement = event.target;
                    if ($('.kitcolors').closest('.js_product_item_kit').siblings('.js-product_addons__product_detail_kit').length) {
                        $('.kitcolors').closest('.js_product_item_kit').siblings('.js-product_addons__product_detail_kit').remove();
                    }
                    actualElement.closest('.product-item-kit').setAttribute('data-product-item-kit-id', res.data.id);
                    actualElement.closest('.product-item-kit').querySelector('.is-selected').classList.remove('is-selected');
                    actualElement.closest('.product__colors-item').classList.add('is-selected');
                    actualElement.closest('.product-item-kit').querySelector('.name span').innerHTML = `${res.data.name}`;
                    actualElement.closest('.product-item-kit').querySelector('.name img').src = `${res.data.thumbnail}`;
                    const actualVariations = actualElement.closest('.product-item-kit').nextElementSibling;
                    actualVariations.innerHTML = '<p class="label_attributes">Selecione o tamanho</p>';
                    var sizes = [];
                    for (i = 0; i <= res.data.variations.length - 1; i++) {
                        if (res.data.variations[i].main_attribute != null) {
                            sizes.splice(res.data.variations[i].main_attribute.order, 0, res.data.variations[i]);
                        }
                    }
                    for (i = 0; i <= sizes.length - 1; i++) {
                        if (sizes[i].main_attribute != null) {
                            var randomNumber = Math.floor(Math.random() * 99999999);
                            var stock = sizes[i].available == false ? 'out-of-stock' : '';
                            actualVariations.insertAdjacentHTML('beforeend', `<input type="radio" name="product_item_variation__product_detail__${res.data.id}_${randomNumber}" id="product_item_variation__product_detail__${sizes[i].id}_${randomNumber}" value="${sizes[i].id}" data-id-auto="" data-variation-name="${sizes[i].main_attribute.name}" data-origin-location="product_detail"><label for="product_item_variation__product_detail__${sizes[i].id}_${randomNumber}" class="label_radio ${stock} radio"><span>${sizes[i].main_attribute.value}</span></label>`);
                        }
                    }
                    if (res.data.addons.length) {
                        var complements = document.createElement('div');
                        complements.setAttribute('id', `js-product_addons__product_detail_${id}`);
                        complements.setAttribute('class', 'complements');
                        complements.setAttribute('complements-for', `${id}`);
                        complements.innerHTML = '<h2 class="complements-title">Complementos:</h2><br>';
                        for (i = 0; i <= res.data.addons.length - 1; i++) {
                            var optional = res.data.addons[i].is_required == false ? 'True' : 'False';
                            var addonPrice = res.data.addons[i].price ? res.data.addons[i].price : '';
                            complements.insertAdjacentHTML('beforeend', `<label class="complements-label-${res.data.addons[i].id}" addon-id="${res.data.addons[i].id}" addon-price="${addonPrice}" for="addon-${res.data.addons[i].id}" data-addon-is-optional="${optional}">${res.data.addons[i].field_label}</label>`);
                            if (res.data.addons[i].field_type == "radio_options") {
                                var complementsSelect = document.createElement('select');
                                complementsSelect.setAttribute('name', `addon-${res.data.addons[i].id}`);
                                complementsSelect.setAttribute('id', `addon-select-${res.data.addons[i].id}`);
                                for (j = 0; j <= res.data.addons[i].field_options.length - 1; j++) {
                                    complementsSelect.add(new Option(`${res.data.addons[i].field_options[j]}`, `${res.data.addons[i].field_options[j]}`));
                                }
                                var selectDiv = document.createElement('div');
                                selectDiv.setAttribute('class', 'complements-content');
                                $(selectDiv).append(complementsSelect);
                                $(complements).append(selectDiv);
                            } else if (res.data.addons[i].field_type == "text") {
                                var selectDiv = document.createElement('div');
                                selectDiv.setAttribute('class', 'complements-content-area');
                                $(selectDiv).append(`<input name="addon-${res.data.addons[i].id}" type="${res.data.addons[i].field_type}" maxlength="${res.data.addons[i].field_char_limit}"></div>`);
                                $(complements).append(selectDiv);
                            }
                        }
                        $('.kitcolors').closest('.itens-for-carousel').append(complements);
                    }
                    $('.kitcolors').height($('.kitcolors').closest('.itens-for-carousel').outerHeight());
                    $(actualElement).closest('.product-item-kit').siblings('.product-radio-variation').find('input').on('change', function () {
                        $(actualElement).closest('.product-item-kit').siblings('.product-radio-variation').find('input').not(this).prop('checked', false);
                    });
                    if (window.outerWidth <= 991) {
                        var slickSlider = $('.product-detail__header--photoArea-mobile');

                        if (slickSlider.hasClass('slick-initialized')) {
                            slickSlider.slick('slickRemove', null, null, true);
                        } else {
                            slickSlider.slick();
                        }

                        for (i = 0; i < res.data.images.length; i++) {
                            slickSlider.slick('slickAdd', `<li><a href="${res.data.images[i]}" data-gallery="gallery3"><img class="product-detail__header--photoArea-mobile-img" src="${res.data.images[i]}" width="100%"></a></li>`);
                        }

                        slickSlider.slick('slickGoTo', 1);
                    } else {
                        const thumsSmall = document.querySelector('.product-detail__header--photoArea-thumbs-default');
                        if (thumsSmall) {
                            var thumsSmallUl = document.querySelector('.product-detail__header--photoArea-thumbs-default ul');

                            // Remova todos os spans dentro do thumsSmallUl
                            while (thumsSmallUl.firstChild) {
                                thumsSmallUl.removeChild(thumsSmallUl.firstChild);
                            }

                            for (i = 0; i <= res.data.images.length - 1; i++) {
                                var li = document.createElement('li');
                                li.innerHTML = `<img src="${res.data.images[i]}" width="100%">`;
                                thumsSmallUl.appendChild(li);
                            }
                        } else {
                            $('.sp-wrap').each(function () {
                                $(this).closest('.slick-slide').remove();
                            });
                            for (i = 0; i <= res.data.images.length - 1; i++) {
                                $('.sp-thumbs').slick('slickAdd', `<div><a class="sp-wrap" href="${res.data.images[i]}" style="background-image: url(${res.data.images[i]}); width: 100%; display: inline-block;" tabindex="0" data-video="undefined"><img src="${res.data.images[i]}" width="100%"></a></div>`, i);
                                if (i == 0) {
                                    document.querySelector('.sp-wrap').click();
                                }
                            }
                        }

                        const noThumbs = document.querySelector('#product-photo');
                        if (noThumbs) {
                            var noThumbsUl = document.querySelector('#product-photo ul');

                            // Remova todos os spans dentro do noThumbsUl
                            while (noThumbsUl.firstChild) {
                                noThumbsUl.removeChild(noThumbsUl.firstChild);
                            }

                            for (i = 0; i <= res.data.images.length - 1; i++) {
                                var li = document.createElement('li');
                                li.innerHTML = `<a href="${res.data.images[i]}" data-gallery="gallery1"><img src="${res.data.images[i]}" width="100%"></a>`;
                                noThumbsUl.appendChild(li);
                            }
                        } else {
                            $('.sp-wrap').each(function () {
                                $(this).closest('.slick-slide').remove();
                            });
                            for (i = 0; i <= res.data.images.length - 1; i++) {
                                $('.sp-thumbs').slick('slickAdd', `<div><a class="sp-wrap" href="${res.data.images[i]}" style="background-image: url(${res.data.images[i]}); width: 100%; display: inline-block;" tabindex="0" data-video="undefined"><img src="${res.data.images[i]}" width="100%"></a></div>`, i);
                                if (i == 0) {
                                    document.querySelector('.sp-wrap').click();
                                }
                            }
                        }

                        this.moveThumbs();
                    }
                })
                .catch(err => {
                    console.log(err)
                })
        },
        resizeThumbs() {
            const contentThumbs = document.querySelector('#product-photo');
            const imgThumb = document.querySelector('#product-photo img');
            if (contentThumbs && imgThumb) {
                let heightImg = imgThumb.getBoundingClientRect().height;
                contentThumbs.style.minHeight = heightImg + 'px';
            }
        },
        clickThumbs() {
            let photoArea = document.querySelector('.product-detail__header--photoArea');
            let photoThumbs = document.querySelector('.product-detail__header--photoArea-thumbs');

            if (photoThumbs && photoArea) {
                if (photoArea.classList.contains('gallery-left') || photoArea.classList.contains('gallery-right') || photoArea.classList.contains('gallery-bottom')) {

                    let photoListItem = document.querySelectorAll('#photo-list li');
                    let singlePhotoItem = document.querySelectorAll('#product-photo img');

                    if (photoListItem.length && singlePhotoItem.length) {
                        photoListItem[0].classList.add('active');
                        singlePhotoItem[0].classList.add('active');

                        function activeTab(index) {
                            singlePhotoItem.forEach((content) => {
                                content.classList.remove('active');
                            });
                            singlePhotoItem[index].classList.add('active');
                        }

                        photoListItem.forEach((itemMenu, index) => {
                            itemMenu.addEventListener('click', () => {
                                activeTab(index);
                            });
                        });
                    }
                }
            }

            if (photoThumbs && photoArea) {
                if (photoThumbs.classList.contains('gallery-left') || photoThumbs.classList.contains('gallery-right')) {
                    $('#photo-list').slick({
                        infinite: false,
                        slidesToShow: 5,
                        vertical: true,
                        slidesToScroll: 1
                    });
                } else if (photoThumbs.classList.contains('gallery-bottom')) {
                    $('#photo-list').slick({
                        infinite: false,
                        slidesToShow: 5,
                        vertical: false,
                        slidesToScroll: 1
                    });
                }
            }
        },
        updateImageThumb(src) {
            this.imgSrc = src;
        },

        setThumbHeight() {
            return document.querySelector('.product-detail__header--photoArea-thumbs').style.height = document.querySelector('#photo-list li.visible').clientHeight * this.slidesToShow + 'px;';
        },

        handleESC(event) {
            if (event.key === 'Escape')
                this.showOpened = false
        },

        checkBuyView() {
            const buyButton = document.getElementById("buy-button");
            const btnFixed = document.querySelector('.product-detail__fixed--buy');
            if (!buyButton || !btnFixed) return;

            // Clona o buy-button uma única vez e o coloca dentro do container fixo
            if (!btnFixed.querySelector('.buy-button-clone')) {
                const btnClone = buyButton.cloneNode(true);
                btnClone.removeAttribute('id');
                btnClone.classList.add('buy-button-clone');

                // cloneNode não copia os eventos (Vue/JS) ligados ao botão original,
                // então o clone nasce sem ação. Encaminhamos o clique do clone
                // para o controle correspondente no botão real.
                btnClone.addEventListener('click', (event) => {
                    const clicked = event.target.closest('button, a');
                    if (!clicked) return;
                    event.preventDefault();
                    // Impede que o clique do clone suba até os handlers delegados
                    // no document (ex.: validação que abre o modal "selecione o tamanho").
                    // Apenas o original.click() abaixo conduz a ação real.
                    event.stopPropagation();
                    const cloneControls = Array.from(btnClone.querySelectorAll('button, a'));
                    const originalControls = buyButton.querySelectorAll('button, a');
                    const original = originalControls[cloneControls.indexOf(clicked)];
                    if (original) original.click();
                });

                btnFixed.appendChild(btnClone);
            }

            const rect = buyButton.getBoundingClientRect();

            if (rect.top >= 0 && rect.bottom <= window.innerHeight) {
                btnFixed.classList.remove("active");
            } else {
                btnFixed.classList.add("active");
            }
        },

        zoom(event) {
            const container = document.getElementById('zoom-container');
            const image = document.getElementById('zoom-image');

            const containerRect = container.getBoundingClientRect();
            const mouseX = event.clientX - containerRect.left;
            const mouseY = event.clientY - containerRect.top;

            if (mouseX >= 0 && mouseX <= containerRect.width && mouseY >= 0 && mouseY <= containerRect.height) {
                const zoomLevel = 1.2;
                const newWidth = container.offsetWidth * zoomLevel;
                const newHeight = container.offsetHeight * zoomLevel;

                const offsetX = -(mouseX * (zoomLevel - 1));
                const offsetY = -(mouseY * (zoomLevel - 1));

                image.style.transform = `translate(${offsetX}px, ${offsetY}px) scale(${zoomLevel})`;

                if (offsetX > 0) {
                    image.style.transform = `translate(0, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY > 0) {
                    image.style.transform = `translate(${offsetX}px, 0) scale(${zoomLevel})`;
                }
                if (offsetX < -(newWidth - container.offsetWidth)) {
                    image.style.transform = `translate(${- (newWidth - container.offsetWidth)}px, ${offsetY}px) scale(${zoomLevel})`;
                }
                if (offsetY < -(newHeight - container.offsetHeight)) {
                    image.style.transform = `translate(${offsetX}px, ${- (newHeight - container.offsetHeight)}px) scale(${zoomLevel})`;
                }
            }
        },

        resetZoom() {
            const image = document.getElementById('zoom-image');
            image.style.transform = 'translate(0, 0) scale(1)';
        },

        clickThumbsMosaic() {
            const thumbs = document.querySelector('.product-detail__header--photoArea-thumbs-default');
            const photos = document.querySelector('#product-photo ul');
            if (thumbs) {
                thumbs.addEventListener('click', function (event) {
                    if (event.target.classList.contains('product-detail__header--photoArea-mobile-img')) {
                        const eventPhoto = event.target.closest('.sp-wrap');
                        const targetPhoto = photos.querySelector(`#${eventPhoto.id}`);
                        if (targetPhoto) {
                            const offset = (window.innerHeight / 2) - (targetPhoto.offsetHeight / 2);
                            const elementPosition = targetPhoto.getBoundingClientRect().top + window.scrollY;

                            window.scrollTo({
                                top: elementPosition - offset,
                                behavior: 'smooth'
                            });
                        }
                    }
                });
            }
        },

        scrollToTop() {
            const upToTop = document.querySelector('.product-detail__up-to-top');
            if (upToTop) {
                upToTop.addEventListener('click', function (e) {
                    e.preventDefault();
                    window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                    });
                });
            }
        },
        moveAddTogetherTemplate() {
            const addTogetherTemplate = document.getElementById('add-together__template');
            const targetDiv = document.querySelector('.product-detail__add-together');

            if (addTogetherTemplate && targetDiv) {
                targetDiv.appendChild(addTogetherTemplate);
                this.addTogetherTemplate = true;
            }
        },
        moveToBuy() {
            var productSize = document.querySelector(".product-detail__header--infoArea-kit");
            if (productSize) {
                productSize.scrollIntoView({ behavior: "smooth", block: "center" });
            }
        }
    },
    mounted() {
        this.moveThumbs();
        this.resizeThumbs();
        this.clickThumbs();
        this.clickThumbsMosaic();
        this.scrollToTop();

        // Verifica periodicamente se o elemento existe e o move
        const checkAndMoveTemplate = setInterval(() => {
            const addTogetherTemplate = document.getElementById('add-together__template');
            const targetDiv = document.querySelector('.product-detail__add-together');

            if (addTogetherTemplate && targetDiv) {
                targetDiv.appendChild(addTogetherTemplate);
                clearInterval(checkAndMoveTemplate);
            }
        }, 100);

        const photoList = document.getElementById("photo-list");
        if (photoList) {
            const firstLi = photoList.querySelector("li");
            if (firstLi) {
                const imgElement = firstLi.querySelector("img");

                if (imgElement) {
                    this.imgSrc = imgElement.getAttribute("src");
                    this.imgTitle = imgElement.getAttribute("title");
                }
            }
        }

        const ratingName = document.querySelector('.product-detail__rating__amount');
        if (ratingName !== null)
            if (ratingName.textContent === 'Seja o primeiro a avaliar')
                ratingName.textContent = 'Avaliar';

        const userLetterElement = document.getElementById('user_letter');
        if (userLetterElement) {
            const userLetter = userLetterElement.innerText.trim();
            if (userLetter.length > 0) {
                userLetterElement.innerText = userLetter[0];
            }
        }

        document.addEventListener('keydown', this.handleESC, { passive: true });
        window.addEventListener("scroll", this.checkBuyView, { passive: true });
        window.addEventListener("load", this.checkBuyView, { passive: true });
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleESC);
    },
})

$(document).ready(function () {

    (function ($) {
        $.fn.visible = function (partial) {

            var $t = $(this),
                $w = $(window),
                viewTop = $w.scrollTop(),
                viewBottom = viewTop + $w.height(),
                _top = $t.offset().top,
                _bottom = _top + $t.height(),
                compareTop = partial === true ? _bottom : _top,
                compareBottom = partial === true ? _top : _bottom;

            setTimeout(() => {
                const productItem = document.querySelectorAll('.product-item');
                if (productItem.length) {
                    // o "+" só entra na lista quando o css escondeu alguma cor
                    // por falta de espaço (o limite varia por breakpoint)
                    productItem.forEach((item) => {
                        const colors = item.querySelectorAll('.product__colors .product__colors-item');
                        const productColors = item.querySelector('.product__colors');
                        const options = item.querySelector('.product-item__options');
                        const more = item.querySelector('.more');

                        if (!colors.length || !productColors || !options || !more) return;

                        const hasHiddenColor = Array.from(colors).some((color) => {
                            return window.getComputedStyle(color).display === 'none';
                        });

                        if (hasHiddenColor) {
                            if (more.parentElement !== productColors) {
                                productColors.appendChild(more);
                            }
                        } else if (more.parentElement !== options) {
                            options.appendChild(more);
                        }
                    });
                }
            }, 500);

            return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
        };

    })(jQuery);

    if (document.querySelector(".carousel-kit")) {
        var splide = new Splide('.carousel-kit', {
            type: "slide",
            autoplay: false,
            rewind: false,
            arrows: false,
            speed: 800,
            perPage: 1,
            perMove: 1,
            drag: false,
            pauseOnFocus: false,
            height: "auto",
            pagination: false,
            breakpoints: {
                768: {
                    drag: false,
                },
            },
        });

        splide.on('mounted', function () {
            var totalSlides = splide.length;
            var nextButton = document.querySelector('.carousel-kit-next');
            nextButton.setAttribute('data-end', totalSlides - 1);
            nextButton.setAttribute('data-actual', 0);

            var addToCartButton = document.querySelector('.js-btn__product_detail__add_to_cart');
            addToCartButton.classList.add('no-buy');

            var countDisplay = document.querySelector('.carousel-count');
            countDisplay.textContent = '1/' + totalSlides;
        });

        splide.mount();

        var nextButton = document.querySelector('.carousel-kit-next');
        var prevButton = document.querySelector('.carousel-kit-prev');
        var message = document.querySelector('.carousel-message');
        var addToCartButton = document.querySelector('.js-btn__product_detail__add_to_cart');
        var countDisplay = document.querySelector('.carousel-count');

        nextButton.addEventListener('click', function () {
            var actual = parseInt(nextButton.getAttribute('data-actual'));
            var end = parseInt(nextButton.getAttribute('data-end'));

            if (actual <= end) {
                var activeSlide = document.querySelector('.splide__slide.is-active');
                var radioChecked = activeSlide.querySelector('.product-radio-variation input[type="radio"]:checked');
                var noVariations = activeSlide.querySelector('.js_product_item_kit').getAttribute('data-no-variations');

                if (radioChecked || noVariations) {
                    splide.go('>');
                    actual = Math.min(actual + 1, end);
                    nextButton.setAttribute('data-actual', actual);
                    message.classList.remove('show');
                    if (actual === end) {
                        addToCartButton.classList.remove('no-buy');
                        nextButton.classList.add('no-click');
                    }
                    if (actual > 0) {
                        prevButton.classList.add('active');
                    }
                } else {
                    message.classList.add('show');
                }
            }
        });

        prevButton.addEventListener('click', function () {
            var actual = parseInt(nextButton.getAttribute('data-actual'));
            var end = parseInt(nextButton.getAttribute('data-end'));

            if (actual <= end && actual > 0) {
                if (actual === end) {
                    nextButton.classList.remove('no-click');
                }
                splide.go('<');
                actual = Math.max(actual - 1, 0);
                nextButton.setAttribute('data-actual', actual);

                if (actual < end) {
                    addToCartButton.classList.add('no-buy');
                }

                if (actual === 0) {
                    prevButton.classList.remove('active');
                }
            }
        });

        splide.on('move', function () {
            var i = splide.index + 1;
            countDisplay.textContent = i + '/' + splide.length;
        });
    }

    const brinde = document.querySelector('#js_buy_together_api_layout_2');

    if (brinde) {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                mutation.addedNodes.forEach(node => {
                    if (node.nodeType === 1) { // Verifica se o nó é um elemento HTML
                        if (node.id === 'js_buy_together_api_group_1' || node.querySelector('#js_buy_together_api_group_1')) {
                            const targetNode = node.id === 'js_buy_together_api_group_1' ? node : node.querySelector('#js_buy_together_api_group_1');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.product-item__content--figcaption');

                            if (options && figcaption) {
                                figcaption.append(options);
                            }

                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');

                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });

                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            }
                        }
                        if (node.id === 'js_buy_together_api_group_2' || node.querySelector('#js_buy_together_api_group_2')) {
                            const targetNode = node.id === 'js_buy_together_api_group_2' ? node : node.querySelector('#js_buy_together_api_group_2');
                            const options = targetNode.querySelector('.product-item__options');
                            const figcaption = targetNode.querySelector('.product-item__content--figcaption');

                            if (options && figcaption) {
                                figcaption.append(options);
                            }

                            const widget = targetNode.querySelector('div[id^="widget_tools__product_detail_list_"]');
                            const sizes = targetNode.querySelector('.product-radio-variation');

                            if (widget && sizes) {
                                widget.addEventListener('click', () => {
                                    sizes.classList.toggle('active');
                                });

                                const allSizes = sizes.querySelectorAll('label');
                                allSizes.forEach(size => {
                                    size.addEventListener('click', () => {
                                        sizes.classList.toggle('active');
                                        widget.setAttribute('data-before', size.textContent);
                                    });
                                });
                            }
                        }
                    }
                });
            });
        });

        observer.observe(brinde, {
            childList: true,
            subtree: true
        });

    }

    $('#widget-sustainability').slick({
        arrows: true,
        dots: false,
        infinite: false,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        speed: 700,

        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            }
        ]
    });

    const galleryCarrousel = document.querySelector('.gallery-carrousel');
    if (galleryCarrousel) {
        $('#product-photo').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            infinite: false,
            mobileFirst: true,
            speed: 1000,
            vertical: false,
        });
    }

    $('.product-detail__header--photoArea-mobile').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        infinite: true,
        mobileFirst: true,
        speed: 700,
        vertical: false,
        responsive: [
            {
                breakpoint: 991,
                settings: "unslick"
            },
        ]
    });

    // O iframe do YouTube captura o toque e impede o swipe do slick.
    // Cobrimos o vídeo com uma camada transparente: arrastar troca de slide,
    // um toque simples libera o iframe para o usuário assistir/controlar.
    function enableVideoSwipe(sliderSelector) {
        const slider = $(sliderSelector);
        if (!slider.length) return;

        function armShields() {
            slider.find('.responsive-video').each(function () {
                const item = this;
                if (!item.querySelector('iframe')) return;

                let shield = item.querySelector('.responsive-video__shield');
                if (!shield) {
                    shield = document.createElement('span');
                    shield.className = 'responsive-video__shield';

                    let startX = 0;
                    let startY = 0;
                    let moved = false;

                    shield.addEventListener('touchstart', function (e) {
                        startX = e.touches[0].clientX;
                        startY = e.touches[0].clientY;
                        moved = false;
                    }, { passive: true });

                    shield.addEventListener('touchmove', function (e) {
                        const deltaX = Math.abs(e.touches[0].clientX - startX);
                        const deltaY = Math.abs(e.touches[0].clientY - startY);
                        if (deltaX > 10 || deltaY > 10) {
                            moved = true;
                        }
                    }, { passive: true });

                    shield.addEventListener('touchend', function () {
                        if (!moved) {
                            item.classList.add('is-video-active');
                        }
                    });

                    shield.addEventListener('click', function () {
                        item.classList.add('is-video-active');
                    });

                    item.appendChild(shield);
                }

                item.classList.remove('is-video-active');
            });
        }

        armShields();

        // ao sair do slide, volta a travar o iframe para o swipe seguir funcionando
        slider.on('afterChange', armShields);
        slider.on('setPosition', armShields);
    }

    enableVideoSwipe('.product-detail__header--photoArea-mobile');
    enableVideoSwipe('#product-photo');

    $('#like-carousel').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        infinite: false,
        mobileFirst: true,
        speed: 700,
        vertical: false,
        responsive: [
            {
                breakpoint: 991,
                settings: "unslick"
            },
        ]
    });

    // Product Rating Review List
    waitForElementToExist('.product-rating__review-list').then(element => {
        $('.product-rating__review-list').slick({
            arrows: false,
            dots: true,
            infinite: false,
            autoplay: true,
            autoplaySpeed: 3000,
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 700,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 4,
                    }
                }
            ]
        });
    });

    $('#product-detail-related-carrousel').slick({
        arrows: true,
        dots: false,
        infinite: false,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 700,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    dots: false,
                    slidesToShow: 4,
                }
            }
        ]
    });

    $('#product-detail-related-carrousel').on('afterChange', function (event, slick, currentSlide, nextSlide) {
        Blazy({
            selector: '.lazy-img',
            successClass: 'loaded-img',
            success: function (element) {
                setTimeout(function () {
                    var parent = element.previousSibling;
                    try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                }, 200);
            }
        });
    });

    let navTab = document.querySelector('.product-detail__nav');
    let nav = document.querySelector('.product-detail__nav-tab');
    let navItem = nav ? nav.querySelectorAll('.nav-item') : [];
    let navContent = document.querySelector('.product-detail__nav-content');
    let navShow = navContent ? navContent.querySelectorAll('.nav-show') : [];

    if (navTab && navItem.length && navShow.length) {
        navItem = Array.from(navItem);
        navShow = Array.from(navShow);

        navItem[0].classList.add('active');
        navShow[0].classList.add('active');

        function activeTab(index) {
            navShow.forEach((content) => {
                content.classList.remove('active');
            });
            navItem.forEach((item) => {
                item.classList.remove('active');
            });
            navShow[index].classList.add('active');
            navItem[index].classList.add('active');
        }

        navItem.forEach((itemMenu, index) => {
            itemMenu.addEventListener('click', () => {
                const isActive = itemMenu.classList.contains('active');

                // Se já estiver ativo, desativa
                if (isActive) {
                    itemMenu.classList.remove('active');
                    navShow[index].classList.remove('active');
                } else {
                    activeTab(index);
                }
            });
        });
    }

});

const photoAreaWrapper = document.querySelector('.product-detail__header--photoArea');
const photoArea = document.querySelector('.product-detail__header--photoArea-thumbs-default');
const header = document.querySelector('#app_header');

function getDistanceFromTop(element) {
    if (!element) return 0;
    return element.offsetTop + getDistanceFromTop(element.offsetParent);
}

window.addEventListener('scroll', () => {
    const photoAreaWrapperHeight = photoAreaWrapper.offsetHeight;
    const photoAreaHeight = photoArea.offsetHeight;
    const headerAreaHeight = header.offsetHeight;

    const offsetTop = getDistanceFromTop(photoAreaWrapper);

    const scrollY = window.scrollY;

    const distance = offsetTop - headerAreaHeight;

    if (distance >= scrollY) {

        photoArea.style.top = `0px`;

    } else if (photoAreaWrapperHeight - photoAreaHeight <= scrollY - distance) {

        photoArea.style.top = `${photoAreaWrapperHeight - photoAreaHeight}px`;

    } else if (distance < scrollY) {

        photoArea.style.top = `${scrollY - distance}px`;

    }
});
/**
 * Modal da galeria de fotos do produto.
 * Substitui o fancybox, que escrevia hash na URL e quebrava a navegação.
 * Os links da galeria usam data-gallery="nome-do-grupo".
 */
(function () {
    const YOUTUBE_REGEX = /(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([\w-]{11})/;
    const VIDEO_REGEX = /\.(mp4|webm|ogg|mov)(\?.*)?$/i;

    let modal = null;
    let slider = null;
    let counter = null;
    let prevArrow = null;
    let nextArrow = null;

    function youtubeSlide(id) {
        return `<div class="gallery-modal__slide"><iframe src="https://www.youtube.com/embed/${id}?rel=0&modestbranding=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>`;
    }

    function videoSlide(src) {
        return `<div class="gallery-modal__slide"><video controls playsinline><source src="${src}"></video></div>`;
    }

    function buildSlide(item) {
        const src = item.src;

        // no cadastro do YouTube o campo guarda só o ID, não a URL completa
        if (item.type === 'youtube') {
            const match = src.match(YOUTUBE_REGEX);
            return youtubeSlide(match ? match[1] : src);
        }

        if (item.type === 'video') return videoSlide(src);

        const youtube = src.match(YOUTUBE_REGEX);
        if (youtube) return youtubeSlide(youtube[1]);

        if (VIDEO_REGEX.test(src)) return videoSlide(src);

        return `<div class="gallery-modal__slide"><img src="${src}" alt=""></div>`;
    }

    function buildModal() {
        modal = document.createElement('div');
        modal.className = 'gallery-modal';
        modal.innerHTML = `
            <div class="gallery-modal__backdrop" data-gallery-close></div>
            <div class="gallery-modal__content">
                <span class="gallery-modal__counter"></span>
                <button type="button" class="gallery-modal__close" aria-label="Fechar" data-gallery-close>
                    <svg viewBox="0 0 24 24"><path d="M18 6 6 18M6 6l12 12"/></svg>
                </button>
                <button type="button" class="gallery-modal__arrow gallery-modal__arrow--prev" aria-label="Anterior">
                    <svg viewBox="0 0 24 24"><path d="m15 18-6-6 6-6"/></svg>
                </button>
                <div class="gallery-modal__slider"></div>
                <button type="button" class="gallery-modal__arrow gallery-modal__arrow--next" aria-label="Próximo">
                    <svg viewBox="0 0 24 24"><path d="m9 18 6-6-6-6"/></svg>
                </button>
            </div>
        `;
        document.body.appendChild(modal);

        slider = modal.querySelector('.gallery-modal__slider');
        counter = modal.querySelector('.gallery-modal__counter');
        prevArrow = modal.querySelector('.gallery-modal__arrow--prev');
        nextArrow = modal.querySelector('.gallery-modal__arrow--next');

        modal.addEventListener('click', function (e) {
            if (e.target.closest('[data-gallery-close]')) {
                closeModal();
            }
        });

        prevArrow.addEventListener('click', () => $(slider).slick('slickPrev'));
        nextArrow.addEventListener('click', () => $(slider).slick('slickNext'));

        document.addEventListener('keydown', function (e) {
            if (!modal.classList.contains('is-open')) return;

            if (e.key === 'Escape') closeModal();
            if (e.key === 'ArrowLeft') $(slider).slick('slickPrev');
            if (e.key === 'ArrowRight') $(slider).slick('slickNext');
        });
    }

    function updateStatus(current, total) {
        counter.textContent = `${current + 1} / ${total}`;
        prevArrow.disabled = current === 0;
        nextArrow.disabled = current === total - 1;
    }

    function openModal(items, index) {
        if (!modal) buildModal();

        slider.innerHTML = items.map(buildSlide).join('');

        modal.classList.add('is-open');
        document.body.classList.add('gallery-modal-open');

        $(slider).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            infinite: false,
            speed: 300,
            initialSlide: index,
            adaptiveHeight: false,
        });

        $(slider).on('afterChange', function (event, slick, currentSlide) {
            // pausa qualquer vídeo que ficou para trás
            slider.querySelectorAll('video').forEach(video => video.pause());
            updateStatus(currentSlide, items.length);
        });

        updateStatus(index, items.length);
    }

    function closeModal() {
        if (!modal) return;

        modal.classList.remove('is-open');
        document.body.classList.remove('gallery-modal-open');

        if ($(slider).hasClass('slick-initialized')) {
            $(slider).slick('unslick');
        }

        // limpar o conteúdo interrompe vídeos e iframes que estavam tocando
        slider.innerHTML = '';
    }

    function sourceOf(element) {
        return element.getAttribute('href') || element.getAttribute('data-gallery-src');
    }

    document.addEventListener('click', function (e) {
        const trigger = e.target.closest('[data-gallery]');
        if (!trigger) return;

        // os vídeos entram na galeria, mas tocam na própria página:
        // só os links (imagens) abrem o modal
        if (!trigger.getAttribute('href')) return;

        e.preventDefault();

        const group = trigger.getAttribute('data-gallery');
        // o slick duplica slides quando é infinito; os clones não podem entrar na lista
        const members = Array.from(document.querySelectorAll(`[data-gallery="${group}"]`))
            .filter(item => sourceOf(item) && !item.closest('.slick-cloned'));

        const items = members.map(item => ({
            src: sourceOf(item),
            type: item.getAttribute('data-gallery-type') || ''
        }));

        let index = members.indexOf(trigger);
        if (index < 0) {
            // clicou num clone: localiza pela imagem correspondente
            index = Math.max(items.findIndex(item => item.src === sourceOf(trigger)), 0);
        }

        if (items.length) openModal(items, index);
    });
})();

/**
 * Blindagem dos vídeos que chegam pelo HTML externo do LP Builder na
 * descrição do produto. Esses arquivos costumam vir pesados, sem faststart
 * e sem controls: o autoplay falha calado e o visitante fica olhando pro
 * fundo preto da section sem nenhuma saída.
 *
 * Aqui a gente segura o download até o vídeo chegar perto da viewport,
 * garante o muted pela propriedade (o atributo sozinho nem sempre basta pro
 * autoplay passar) e, se ainda assim não tocar, entrega controls e um botão
 * de play pro usuário resolver na mão.
 */
(function () {
    const videos = document.querySelectorAll('.product-detail__description-resumida video');
    if (!videos.length) return;

    // tempo até desistir do autoplay e devolver o controle pro usuário
    const ESPERA_MAXIMA = 8000;

    function liberarControles(video) {
        if (video.dataset.spbLiberado) return;
        video.dataset.spbLiberado = '1';
        video.controls = true;

        const alvo = video.parentElement;
        if (!alvo || alvo.querySelector('.spb-video-play')) return;

        const botao = document.createElement('button');
        botao.type = 'button';
        botao.className = 'spb-video-play';
        botao.setAttribute('aria-label', 'Reproduzir vídeo');
        botao.addEventListener('click', function () {
            const tentativa = video.play();
            if (tentativa && typeof tentativa.catch === 'function') tentativa.catch(function () {});
            botao.remove();
        });
        alvo.appendChild(botao);
    }

    // tira o src de circulação pra abortar o download que o preload="auto"
    // já disparou durante o parse da página
    function desarmar(video) {
        if (video.hasAttribute('src')) {
            video.dataset.spbSrc = video.getAttribute('src');
            video.removeAttribute('src');
        }
        video.querySelectorAll('source[src]').forEach(function (fonte) {
            fonte.dataset.spbSrc = fonte.getAttribute('src');
            fonte.removeAttribute('src');
        });
        video.preload = 'metadata';
        video.removeAttribute('autoplay');
        video.load();
    }

    function armar(video) {
        if (video.dataset.spbArmado) return;
        video.dataset.spbArmado = '1';

        if (video.dataset.spbSrc) video.setAttribute('src', video.dataset.spbSrc);
        video.querySelectorAll('source[data-spb-src]').forEach(function (fonte) {
            fonte.setAttribute('src', fonte.dataset.spbSrc);
        });

        // formato que o browser recusa (.mov/quicktime no Firefox, por ex.)
        // não pode terminar em tela preta silenciosa
        video.addEventListener('error', function () { liberarControles(video); });
        video.load();

        video.muted = true;
        video.playsInline = true;

        const tentativa = video.play();
        if (tentativa && typeof tentativa.catch === 'function') {
            tentativa.catch(function () { liberarControles(video); });
        }

        // arquivo sem faststart pode exigir o download inteiro antes do
        // primeiro frame: estourou o limite, o usuário assume o controle
        const limite = setTimeout(function () {
            if (video.readyState < 3) liberarControles(video);
        }, ESPERA_MAXIMA);

        video.addEventListener('playing', function () { clearTimeout(limite); }, { once: true });
    }

    videos.forEach(desarmar);

    if (!('IntersectionObserver' in window)) {
        videos.forEach(armar);
        return;
    }

    const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            armar(entry.target);
            observer.unobserve(entry.target);
        });
    }, { rootMargin: '200px' });

    videos.forEach(function (video) { observer.observe(video); });
})();
